import React, { useState } from 'react';
import { petsWithAddresses, drivers, routes, routeHistory } from '../mock/routesData';
import RouteMap from '../components/RouteMap';
import RouteStop from '../components/RouteStop';
import RouteHistory from '../components/RouteHistory';
import NewRouteModal from '../components/NewRouteModal';

const RoutesPage = () => {
  const [currentUser] = useState({ id: 'user-003', role: 'admin' });
  const [activeRoute, setActiveRoute] = useState(routes[0]);
  const [dateFilter, setDateFilter] = useState('2023-06-15');
  const [showNewRouteModal, setShowNewRouteModal] = useState(false);
  const [view, setView] = useState('current'); // 'current' or 'history'

  const filteredRoutes = routes.filter(route => route.date === dateFilter);
  const currentDriver = drivers.find(d => d.id === activeRoute.driverId);

  const handleCreateRoute = (newRoute) => {
    // En una app real, esto se enviaría al backend
    const routeWithId = {
      ...newRoute,
      id: `route-${Date.now()}`,
      stops: newRoute.stops.map((stop, i) => ({
        ...stop,
        status: 'pending',
        actualTime: null
      }))
    };
    setActiveRoute(routeWithId);
    setDateFilter(newRoute.date);
  };

  return (
    <div className="ml-48 p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-800">Rutas de Transporte</h2>
        
        <div className="flex items-center space-x-2">
          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            className="px-3 py-1 border border-gray-300 rounded-md text-sm"
          />
          
          <div className="flex border border-gray-300 rounded-md overflow-hidden">
            <button
              onClick={() => setView('current')}
              className={`px-3 py-1 text-sm ${view === 'current' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
            >
              Actual
            </button>
            <button
              onClick={() => setView('history')}
              className={`px-3 py-1 text-sm ${view === 'history' ? 'bg-cyan-600 text-white' : 'bg-white'}`}
            >
              Historial
            </button>
          </div>

          {currentUser.role === 'admin' && view === 'current' && (
            <button
              onClick={() => setShowNewRouteModal(true)}
              className="flex items-center px-3 py-1 bg-cyan-600 text-white rounded-md text-sm hover:bg-cyan-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Nueva Ruta
            </button>
          )}
        </div>
      </div>

      {view === 'current' ? (
        filteredRoutes.length > 0 ? (
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow-sm p-4">
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="font-medium">
                    {activeRoute.type === 'morning' ? 'Ruta Mañana' : 'Ruta Tarde'} - {activeRoute.date}
                  </h3>
                  <p className="text-sm text-gray-600">
                    Conductor: {currentDriver?.name} - {currentDriver?.vehicle}
                  </p>
                </div>
                <span className="bg-cyan-100 text-cyan-800 px-2 py-1 rounded-full text-xs">
                  {activeRoute.stops.filter(s => s.status === 'completed').length}/{activeRoute.stops.length} completados
                </span>
              </div>
            </div>

            <RouteMap route={activeRoute} pets={petsWithAddresses} />

            <div className="bg-white rounded-lg shadow-sm p-4">
              <h3 className="text-sm font-semibold mb-3">Paradas</h3>
              <div className="space-y-2">
                {activeRoute.stops.map((stop, index) => (
                  <RouteStop
                    key={index}
                    stop={stop}
                    pets={petsWithAddresses}
                    isDriver={currentUser.role === 'driver'}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm p-8 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-gray-500 mt-2">No hay rutas programadas para esta fecha</p>
          </div>
        )
      ) : (
        <RouteHistory 
          history={routeHistory} 
          pets={petsWithAddresses} 
          drivers={drivers} 
        />
      )}

      {showNewRouteModal && (
        <NewRouteModal
          pets={petsWithAddresses}
          drivers={drivers}
          onClose={() => setShowNewRouteModal(false)}
          onSave={handleCreateRoute}
        />
      )}
    </div>
  );
};

export default RoutesPage;

// DONE